'use client';

import { createContext, useContext } from 'react';

import { SettingsContextProps } from '@/utils/settings-theme';

export const SettingsContext = createContext({} as SettingsContextProps);

export const useSettingsContext = () => {
  const context = useContext(SettingsContext);

  return context;
};
